import { EnhancedWithAuthHttpService } from './http-auth.service'
import axios, { Canceler } from 'axios'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  ICancelRemovalDto,
  IImpactLibraryByIdRespDto,
  IImpactLibraryCreateDto,
  IImpactLibrarySuggestDto,
  IImpactLibraryUpdateDto,
  IImpactsLibraryDtoWithCount,
  IMessageResponseDto,
} from 'src/types'

class ImpactsLibraryService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }
  createLibraryImpact(dto: IImpactLibraryCreateDto) {
    return this.post<IMessageResponseDto, IImpactLibraryCreateDto>(`impacts-library`, dto)
  }

  suggestLibraryImpact(dto: IImpactLibrarySuggestDto) {
    return this.post<IMessageResponseDto, IImpactLibrarySuggestDto>(
      `impacts-library/suggestion`,
      dto,
    )
  }

  getLibraryImpactById(id: string) {
    return this.get<IImpactLibraryByIdRespDto>(`impacts-library/${id}`)
  }

  updateLibraryImpact(dto: IImpactLibraryUpdateDto, id: string) {
    return this.put<string, IImpactLibraryUpdateDto>(`impacts-library/${id}`, dto)
  }

  removeLibraryImpacts(ids: string[]) {
    return this.delete<string>(`impacts-library`, { data: { ids } })
  }

  cancelRemove(params: ICancelRemovalDto) {
    return this.get<IMessageResponseDto>('impacts-library/cancel-deletion', { params })
  }

  getLibraryImpacts(params?: {}) {
    return this.get<IImpactsLibraryDtoWithCount>(`impacts-library`, { params })
  }

  getFilteredLibraryImpacts(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }

    return this.get<IImpactsLibraryDtoWithCount>(`impacts-library`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }
}

export const impactsLibraryService = new ImpactsLibraryService()
export default ImpactsLibraryService
